import React, { useEffect, useState } from "react";
import { Card, Tab } from "react-bootstrap";

import UploadStep from "./steps/UploadStep";
import ValidateStep from "./steps/ValidateStep";
import ImportStep from "./steps/ImportStep";
import DoneStep from "./steps/DoneStep";

import ImportWizardNav from "./components/ImportWizardNav";
import ImportWizardFooter from "./components/ImportWizardFooter";

import {
    clearFiles,
    selectAllImported,
    selectAllValidated,
    selectWizardFiles
} from "./dataImportWizardSlice";
import { useAppDispatch, useAppSelector } from "../config/store";

type Step = 1 | 2 | 3 | 4;

export default function DataImportWizard() {
    const dispatch = useAppDispatch();

    const files = useAppSelector(selectWizardFiles);
    const allValidated = useAppSelector(selectAllValidated);
    const allImported = useAppSelector(selectAllImported);

    const [activeStep, setActiveStep] = useState<Step>(1);

    const canGoStep2 = files.length > 0;
    const canGoStep3 = allValidated === true;
    const canGoStep4 = allImported === true;

    const goTo = (step: Step) => {
        if (step === 2 && !canGoStep2) return;
        if (step === 3 && !canGoStep3) return;
        if (step === 4 && !canGoStep4) return;
        setActiveStep(step);
    };

    // Se removeu arquivos e estava no step 2+, volta pro step 1
    useEffect(() => {
        if (activeStep >= 2 && !canGoStep2) setActiveStep(1);
    }, [activeStep, canGoStep2]);

    // Se invalida validação enquanto está no step 3+, volta pro step 2
    useEffect(() => {
        if (activeStep >= 3 && !canGoStep3) setActiveStep(2);
    }, [activeStep, canGoStep3]);

    // Se invalida importação enquanto está no step 4, volta pro step 3
    useEffect(() => {
        if (activeStep >= 4 && !canGoStep4) setActiveStep(3);
    }, [activeStep, canGoStep4]);


    const handleFinish = () => {
        dispatch(clearFiles());
        setActiveStep(1);
    };


    // Se validou tudo, libera step 3 (não auto-avança; você decide)
    // Se importou tudo, libera step 4 (não auto-avança; você decide)
    // Se quiser auto-avançar, descomente:
    // useEffect(() => { if (canGoStep3) setActiveStep(3); }, [canGoStep3]);
    // useEffect(() => { if (canGoStep4) setActiveStep(4); }, [canGoStep4]);

    return (
        <Tab.Container activeKey={activeStep} onSelect={(k) => goTo(Number(k) as Step)}>
            <Card className="theme-wizard">
                <Card.Header className="bg-body-highlight pt-3 pb-2 border-bottom-0">
                    <ImportWizardNav
                        activeStep={activeStep}
                        canGoStep2={canGoStep2}
                        canGoStep3={canGoStep3}
                        canGoStep4={canGoStep4}
                    />

                </Card.Header>

                <Card.Body>
                    <Tab.Content>
                        <Tab.Pane eventKey={1}>
                            <UploadStep />
                        </Tab.Pane>

                        <Tab.Pane eventKey={2}>
                            <ValidateStep />
                        </Tab.Pane>

                        <Tab.Pane eventKey={3}>
                            <ImportStep />
                        </Tab.Pane>

                        <Tab.Pane eventKey={4}>
                            <DoneStep />
                        </Tab.Pane>
                    </Tab.Content>
                </Card.Body>

                <Card.Footer className="border-top-0">
                    <ImportWizardFooter
                        activeStep={activeStep}
                        goTo={goTo}
                        canGoStep2={canGoStep2}
                        canGoStep3={canGoStep3}
                        canGoStep4={canGoStep4}
                        onFinish={handleFinish}
                    />
                </Card.Footer>
            </Card>
        </Tab.Container>
    );
}